import BusinessLogicService from './businesslogic.service'

const module = angular.module('mpa.commons.businesslogic', [])

module.service('BusinessLogic', BusinessLogicService)

export default module.name
